import { formatNameLastFirst } from '@strata/helper-functions';
import { StatusIndicator } from '@strata/react-status-indicators';

// Wire values from agora-monitor RequestState; chip labels/colors are UI-only.
export const RequestStatusIndicatorMap = {
    new: { message: 'New', status: StatusIndicator.Status.DEFAULT },
    in_progress: { message: 'In Progress', status: StatusIndicator.Status.IN_PROGRESS },
    waiting_on_response: {
        message: 'Waiting on Response',
        status: StatusIndicator.Status.WARNING,
    },
    resolved: { message: 'Resolved', status: StatusIndicator.Status.SUCCESS },
};

export const RequestStatusDisplayTextMap = Object.fromEntries(
    Object.entries(RequestStatusIndicatorMap).map(([value, { message }]) => [value, message]),
);

export const UNASSIGNED_LABEL = 'Unassigned';

/** Sentinel matching agora-monitor `assigned_to=__unassigned__` (queues + resolved). */
export const UNASSIGNED_FILTER = '__unassigned__';

const mapRequestListRowCommon = (request) => ({
    requestId: request.request_id,
    referralId: request.referral_id ?? undefined,
    requestTypeCode: request.request_type_code,
    requestTypeName: request.request_type_name,
    requestCategoryKey: request.request_category_key ?? undefined,
    requestCategoryName: request.request_category_name ?? undefined,
    state: request.state,
    patientName: formatNameLastFirst(request.patient_last_name, request.patient_first_name),
    drugName: request.drug_name ?? undefined,
    pharmacyName: request.pharmacy_name ?? undefined,
    pharmacyNpi: request.pharmacy_npi ?? undefined,
    assignedTo: request.assigned_to ?? undefined,
});

export const mapRequest = (request) => ({
    ...mapRequestListRowCommon(request),
    urgencyScore: request.urgency_score,
    urgencyBand: request.urgency_band ?? undefined,
    needsByDate: request.needs_by_date ?? undefined,
    sla: request.sla
        ? {
              code: request.sla.code,
              dueUtc: request.sla.due_utc,
              band: request.sla.band,
              businessMinutesRemaining: request.sla.business_minutes_remaining,
              clockState: request.sla.clock_state,
              resumesAtUtc: request.sla.resumes_at_utc ?? undefined,
          }
        : undefined,
});

export const mapResolvedRequest = (request) => ({
    ...mapRequestListRowCommon(request),
    resolvedAtUtc: request.resolved_at_utc ?? undefined,
});
